<template>
	<div class="">
	<van-radio-group v-model="select"  >
		<div class="form" v-for='(item,index) in dataList' :key='index'>
			<div class="title">
				<div>
					<image src="../../static/imgs/no.png" mode="widthFix"></image>
					<span>NO: {{item.batchModel == '3' ?item.noticeNo:item.batchNo}}</span>
				</div>
				<span>{{item.isConfirm==0?'未缴费':item.isConfirm==1?'已缴费':item.isConfirm==9?'支付中':''}}</span>
			</div>
			<div class="contentbox">
				<div >
					<span>执收单位</span>
					<span>:</span>
					<span>{{item.deptName}}</span>
				</div>
				<div >
					<span>缴款单位</span>
					<span>:</span>
					<span>{{item.paymentUnit}}</span>
				</div>
				<div>
					<span>证件号码</span>
					<span>:</span>
					<span>{{item.idCard?item.idCard:'未录入'}}</span>
				</div>
				 <div>
					<span>手机号码</span>
					<span>:</span>
					<span>{{item.phone?item.phone:'未录入'}}</span>
				</div>
				<div>
					<span>业务类型</span>
					<span>:</span>
					<span>{{item.batchModel == '3'?'个件':'批量件'}}</span>
				</div>
				<div class="money">
					<span>金额</span>
					<span>:</span>
					<span>{{item.paymentTotal}}元</span>
				</div>
			</div>
			<div class="cu-form-group">
				<div @click="handleItem(index)">项目详情</div>
				<div v-if='isTicket'  @click="printNotice(index)">打印小票</div>
                <div  v-if='item.batchModel != 3 && isBatch != "1" ' @click="getBatchDetail(index)">查看批量件明细</div>
                <div  v-if='(item.batchModel == 3 || item.batchModel == 2) && item.isConfirm==1 && item.isETicket==true' @click="getEticket(index,1)">查看电子票</div>
                <div  v-if='isBatch == "1" && item.batchModel == 1 && item.isConfirm==1 && item.eticket==true' @click="getEticket(index,2)">查看电子票</div>
				<div v-else-if=' (item.bizId == null || item.bizId == "" || item.bizId == undefined)
					&& (item.isConfirm == 0 || item.isConfirm == 9)'>
					<van-radio  :name="index" @click="handleSelect(index)"></van-radio>
				</div>
				<div v-else-if='item.isConfirm==1 && item.isETicket==false'>{{item.payCode}}</div>
			</div>
		</div>
	</van-radio-group>
	</div>
</template>

<script>
import { Toast,Dialog } from "vant";
	export default {
		props:['dataList','isTicket','isBatch','checkedMark'],
		data() {
			return {
				detailList:[],
				showModel:false,
				idx:0,
				select:-1
			}
		},
		created	() {
			const $this = this;
			this.dataList.forEach((val,index)=>{
				if(val.uId == $this.checkedMark) {
					$this.select = index
					val.checked = true
				}else{
					val.checked=false
				}

			})
		},
		methods: {
			// 项目详情
			handleItem(index) {
				this.idx=index
				this.showModel=true
				this.detailList=this.dataList[index].items
				this.$forceUpdate()
				this.$emit('func',this.showModel,this.detailList)
			},
			// 选择要支付的信息
			handleSelect(index) {
				this.dataList.forEach((val) => {
					val.checked=false
				})
				this.dataList[index].checked = true	
			},
			// 查看电子票
			getEticket(index,type) {
				//这里可以考虑直接用返回的电子票链接，不用每次都请求后台
				let data = {}
				data.bizId = this.dataList[index].uId
				data.sysType = type;
				this.request({
					baseURL: process.env.VUE_APP_PAY_URL,
					url:'/pay/showETicketBdc',
					method:'get',
					params:data
				}).then((res)=>{
					if (res.data.code == 1000) {
						window.location.href=res.data.message
					}else {
						 Toast(res.data.message);
					}
				})
			},
			printNotice(index) {
				this.$emit('printNotice', index);
			},
			getBatchDetail(index){
				this.$router.push({path: "/bdcPay/batchList?bizId=" + this.dataList[index].uId });
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.form {
		border-radius:2px;
		box-sizing: border-box;
		background-color: #fff;
		box-shadow:4px 4px 5px 0px rgba(51,51,51,0.05);
        border-radius:5px;
		margin-bottom: 15px;
		.title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height:32px;
			box-sizing: border-box;
			padding: 0 14px;
			border-radius:2px 2px 0px 0px;
			background:#1989fa;
			>div {
				image {
					width: 14px;
					margin-right: 13px;
					position: relative;
					top: 2px;
				}
			}
			span {
				font-size:15px;
				font-family:PingFang SC;
				font-weight:400;
				color:rgba(255,255,255,1);
				line-height:31px;
			}
		}
		>.contentbox {
			padding: 5px 14px 0 14px;
			font-size: 14px;
			>div {
				display: flex;
				height: 25px;
				line-height: 25px;
				color:rgba(102,102,102,1);
				> span:nth-of-type(1) {
					display: inline-block;
					width: 80px;
					text-align: justify;
					font-size:14px;
					font-family:PingFang SC;
					color:rgba(102,102,102,1);
					vertical-align: top;
					&::after {
						display: inline-block;
						width: 100%;
						content: '';
						height: 0;
					}
				}
				>span:nth-of-type(2) {
					line-height: 25px;
					margin-left: 0;
					position: relative;
				}
				>span:nth-of-type(3) {
					width: 200px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					color:rgba(51,51,51,1);
					margin-left: 18px;
					display: inline-block;
				}
			}
		
			.money {
				>span:nth-of-type(3) {
					color: #FF774D;
				}
			}
		}
		.cu-form-group {
			margin-top: 5px;
			border-top: 1px dashed #C8C8C8;
			display: flex;
			justify-content: space-between;
			padding: 10px;
			align-items: center;
			position: relative;
			z-index: 99;
			>div {
				font-size:13px;
				font-family:PingFang SC;
				color:rgba(8,148,235,1);
			}
		}
	}
	
	.model {
		width: 100vw;
		height: 100vh;
		background-color: #000;
		opacity: 0.3;
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		z-index: 100;
		overflow: hidden;
	}

	.content {
		text-align: center;
		padding: 15px 0;
		line-height: 24px;
	}

	
	
</style>
